// Zalo emoji code to image URL mapping
export const emojiCodeToUrlMap: Record<string, string> = {
  ":)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/16.png",
  ":~": "https://stc-oa-chat-adm.zdn.vn/images/emoji/10.png",
  ":b": "https://stc-oa-chat-adm.zdn.vn/images/emoji/8.png",
  ":')": "https://stc-oa-chat-adm.zdn.vn/images/emoji/2.png",
  "8-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/22.png",
  ":-((": "https://stc-oa-chat-adm.zdn.vn/images/emoji/20.png",
  ":$": "https://stc-oa-chat-adm.zdn.vn/images/emoji/18.png",
  ":3": "https://stc-oa-chat-adm.zdn.vn/images/emoji/6.png",
  ":z": "https://stc-oa-chat-adm.zdn.vn/images/emoji/33.png",
  ":((": "https://stc-oa-chat-adm.zdn.vn/images/emoji/15.png",
  "&-(": "https://stc-oa-chat-adm.zdn.vn/images/emoji/44.png",
  ":-h": "https://stc-oa-chat-adm.zdn.vn/images/emoji/19.png",
  ":p": "https://stc-oa-chat-adm.zdn.vn/images/emoji/17.png",
  ":d": "https://stc-oa-chat-adm.zdn.vn/images/emoji/1.png",
  ":o": "https://stc-oa-chat-adm.zdn.vn/images/emoji/32.png",
  ":(": "https://stc-oa-chat-adm.zdn.vn/images/emoji/25.png",
  ";-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/85.png",
  "--b": "https://stc-oa-chat-adm.zdn.vn/images/emoji/7.png",
  ":))": "https://stc-oa-chat-adm.zdn.vn/images/emoji/62.png",
  ":-*": "https://stc-oa-chat-adm.zdn.vn/images/emoji/3.png",
  ";p": "https://stc-oa-chat-adm.zdn.vn/images/emoji/12.png",
  ";-d": "https://stc-oa-chat-adm.zdn.vn/images/emoji/23.png",
  "/-showlove": "https://stc-oa-chat-adm.zdn.vn/images/emoji/51.png",
  ";d": "https://stc-oa-chat-adm.zdn.vn/images/emoji/9.png",
  ";o": "https://stc-oa-chat-adm.zdn.vn/images/emoji/14.png",
  ";g": "https://stc-oa-chat-adm.zdn.vn/images/emoji/31.png",
  "|-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/38.png",
  ":!": "https://stc-oa-chat-adm.zdn.vn/images/emoji/40.png",
  ":l": "https://stc-oa-chat-adm.zdn.vn/images/emoji/34.png",
  ":>": "https://stc-oa-chat-adm.zdn.vn/images/emoji/11.png",
  ":;": "https://stc-oa-chat-adm.zdn.vn/images/emoji/58.png",
  ";f": "https://stc-oa-chat-adm.zdn.vn/images/emoji/57.png",
  ":v": "https://stc-oa-chat-adm.zdn.vn/images/emoji/90.png",
  ":wipe": "https://stc-oa-chat-adm.zdn.vn/images/emoji/39.png",
  ":-dig": "https://stc-oa-chat-adm.zdn.vn/images/emoji/42.png",
  ":handclap": "https://stc-oa-chat-adm.zdn.vn/images/emoji/46.png",
  "b-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/26.png",
  ":-r": "https://stc-oa-chat-adm.zdn.vn/images/emoji/50.png",
  ":-<": "https://stc-oa-chat-adm.zdn.vn/images/emoji/61.png",
  ":-o": "https://stc-oa-chat-adm.zdn.vn/images/emoji/53.png",
  ";-s": "https://stc-oa-chat-adm.zdn.vn/images/emoji/54.png",
  ";?": "https://stc-oa-chat-adm.zdn.vn/images/emoji/27.png",
  ";-x": "https://stc-oa-chat-adm.zdn.vn/images/emoji/52.png",
  ":-f": "https://stc-oa-chat-adm.zdn.vn/images/emoji/48.png",
  "8*)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/91.png",
  ";!": "https://stc-oa-chat-adm.zdn.vn/images/emoji/56.png",
  ";-!": "https://stc-oa-chat-adm.zdn.vn/images/emoji/63.png",
  ";xx": "https://stc-oa-chat-adm.zdn.vn/images/emoji/29.png",
  ":-bye": "https://stc-oa-chat-adm.zdn.vn/images/emoji/36.png",
  ">-|": "https://stc-oa-chat-adm.zdn.vn/images/emoji/47.png",
  "p-(": "https://stc-oa-chat-adm.zdn.vn/images/emoji/35.png",
  ":--|": "https://stc-oa-chat-adm.zdn.vn/images/emoji/30.png",
  ":q": "https://stc-oa-chat-adm.zdn.vn/images/emoji/24.png",
  "x-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/21.png",
  ":*": "https://stc-oa-chat-adm.zdn.vn/images/emoji/13.png",
  ";-a": "https://stc-oa-chat-adm.zdn.vn/images/emoji/60.png",
  "8*": "https://stc-oa-chat-adm.zdn.vn/images/emoji/41.png",
  ":|": "https://stc-oa-chat-adm.zdn.vn/images/emoji/28.png",
  ":x": "https://stc-oa-chat-adm.zdn.vn/images/emoji/37.png",
  ":t": "https://stc-oa-chat-adm.zdn.vn/images/emoji/43.png",
  ";-/": "https://stc-oa-chat-adm.zdn.vn/images/emoji/87.png",
  ":-l": "https://stc-oa-chat-adm.zdn.vn/images/emoji/49.png",
  "$-)": "https://stc-oa-chat-adm.zdn.vn/images/emoji/89.png",
  "/-beer": "https://stc-oa-chat-adm.zdn.vn/images/emoji/64.png",
  "/-coffee": "https://stc-oa-chat-adm.zdn.vn/images/emoji/65.png",
  "/-rose": "https://stc-oa-chat-adm.zdn.vn/images/emoji/66.png",
  "/-fade": "https://stc-oa-chat-adm.zdn.vn/images/emoji/67.png",
  "/-bd": "https://stc-oa-chat-adm.zdn.vn/images/emoji/68.png",
  "/-bome": "https://stc-oa-chat-adm.zdn.vn/images/emoji/69.png",
  "/-cake": "https://stc-oa-chat-adm.zdn.vn/images/emoji/70.png",
  "/-heart": "https://stc-oa-chat-adm.zdn.vn/images/emoji/4.png",
  "/-break": "https://stc-oa-chat-adm.zdn.vn/images/emoji/71.png",
  "/-shit": "https://stc-oa-chat-adm.zdn.vn/images/emoji/72.png",
  "/-li": "https://stc-oa-chat-adm.zdn.vn/images/emoji/73.png",
  "/-flag": "https://stc-oa-chat-adm.zdn.vn/images/emoji/84.png",
  "/-strong": "https://stc-oa-chat-adm.zdn.vn/images/emoji/5.png",
  "/-weak": "https://stc-oa-chat-adm.zdn.vn/images/emoji/74.png",
  "/-ok": "https://stc-oa-chat-adm.zdn.vn/images/emoji/75.png",
  "/-v": "https://stc-oa-chat-adm.zdn.vn/images/emoji/76.png",
  "/-thanks": "https://stc-oa-chat-adm.zdn.vn/images/emoji/77.png",
  "/-punch": "https://stc-oa-chat-adm.zdn.vn/images/emoji/78.png",
  "/-share": "https://stc-oa-chat-adm.zdn.vn/images/emoji/79.png",
  "_()_": "https://stc-oa-chat-adm.zdn.vn/images/emoji/88.png",
  "/-no": "https://stc-oa-chat-adm.zdn.vn/images/emoji/81.png",
  "/-bad": "https://stc-oa-chat-adm.zdn.vn/images/emoji/82.png",
  "/-loveu": "https://stc-oa-chat-adm.zdn.vn/images/emoji/83.png",
};

// Helper function to get emoji image URL by code
export function getEmojiImageUrl(emojiCode: string): string | undefined {
  return emojiCodeToUrlMap[emojiCode];
}

